export default "__VITE_ASSET__d72d0204__"